import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
// import "./assets/css/notifications.css";

import jwt from "jsonwebtoken";

import {
  isMultiColorActive,
  defaultColor,
  themeColorStorageKey,
  isDarkSwitchActive
} from "./constants/defaultValues";

// Early bootstrap: capture refresh/access token from URL before anything else runs
try {
  const search = window.location.search || "";
  if (search.includes("token=")) {
    const params = new URLSearchParams(search);
    let token = params.get("token");
    if (token) {
      // Strip any surrounding quotes that might be present
      token = token.replace(/^"|"$/g, "");
      // Store raw token optimistically as refresh; interceptor expects this key
      localStorage.setItem("jwtRefresh", token);
      // Also store in sessionStorage for HTTP scenarios
      sessionStorage.setItem("jwtRefresh", token);
      
      // If it's actually an access token, also set jwt so app can proceed seamlessly
      try {
        const decoded = jwt.decode(token, { complete: true });
        if (decoded && decoded.payload) {
          const type = decoded.payload.token_type;
          if (type === "access") {
            localStorage.setItem("jwt", token);
            sessionStorage.setItem("jwt", token);
            console.log("✅ Access token stored in both localStorage and sessionStorage");
          }
        }
      } catch (_) {
        // noop - token might be opaque or not decodable; refresh flow will handle errors
      }
    }
  }
} catch (_) {
  // ignore bootstrap token capture errors
}

const color =
  (isMultiColorActive || isDarkSwitchActive) &&
    localStorage.getItem(themeColorStorageKey)
    ? localStorage.getItem(themeColorStorageKey)
    : defaultColor;

localStorage.setItem(themeColorStorageKey, color);

let render = () => {
  import("./assets/css/sass/themes/gogo." + color + ".scss").then(x => {
    require("./AppRenderer");
  });
};
render();
